export enum AiMode {
  Default = 'GP Mode',
  ER = 'ER Mode',
}
